//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { conversion } from "@/tool";
import InteractivePanel from "@/components/interactive_panel";
import battleCaseDetail from "./battleCaseDetail.vue";
import * as apis from "@/api";
export default {
  name: "NewCase",
  data() {
    return {
      isShow: false,
      current_case_title: "全部",
      toggleCasePriceSortFlag: false,
      /** 箱子详情 */
      case_detail_modal: {
        flag: false,
        caseInfo: {},
      },
      roomPassword: "",
      lowCount: 1,
      lastShowPrice: 0,
      lastCreatePrice: 0,
      loading: false,
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    battleCaseList: {
      type: Array,
      default: () => [],
    },
    caseData: {
      type: Array,
      default: () => [],
    },
    mpcCaseSettings: {
      type: Object,
      default: () => ({
        mpCaseMaximumPercent: 0,
        mpCaseMinimumPercent: 0,
        mpCaseOwnerDiscount: 0,
        mpCaseMinimumPrice: 0
      }),
    },
  },
  model: {
    prop: "value",
    event: "on-sync",
  },
  watch: {
    value(v) {
      this.isShow = v;
    },
    isShow(v) {
      this.$emit("on-sync", v);
    },
    totalSelectedPrice(val) {
      this.lastShowPrice = conversion(
        Number(val * this.mpcCaseSettings.mpCaseMinimumPercent * this.lowCount)
      );
      this.lastCreatePrice = conversion(
        Number(this.lastShowPrice * this.mpcCaseSettings.mpCaseOwnerDiscount)
      );
    },
    lowCount(val) {
      this.lastShowPrice = conversion(
        Number(
          this.totalSelectedPrice *
            this.mpcCaseSettings.mpCaseMinimumPercent *
            val
        )
      );
      this.lastCreatePrice = conversion(
        Number(this.lastShowPrice * this.mpcCaseSettings.mpCaseOwnerDiscount)
      );
    },
  },
  components: {
    "c-interactive-panel": InteractivePanel,
    "c-battleCaseDetail": battleCaseDetail,
  },
  computed: {
    /** 箱子列表 */
    cases_types() {
      let list = this.battleCaseList.map((_) => {
        return _.isShowInMPCase ? _.catagory : "";
      });
      list.unshift("全部");
      var types = new Set(list);
      return types;
    },
    totalSelectedCount() {
      return this.caseData.reduce((a, b) => a + b.count, 0);
    },
    totalSelectedPrice() {
      return this.caseData.reduce((a, b) => a + b.price * b.count, 0);
    },
  },
  filters: {
    conversion,
  },
  methods: {
    reset() {
      this.loading = false;
    },
    close() {
      this.loading = false;
      this.$refs.NewCase.style.display = "none";
      this.getUserInfo();
    },
    getUserInfo() {
      userService.getUserInfo().then((res) => {
        window.$rootApp.$store.commit("user/updateInfo", res);
      });
    },
    //箱子价格排序
    toggleCasePriceOrder() {
      this.caseData.reverse();
      this.toggleCasePriceSortFlag = !this.toggleCasePriceSortFlag;
    },
    async openCaseDetailModal(item) {
      const case_info_response = await apis.api_CaseDetail(item.caseId);

      if (case_info_response.data.code !== 0) {
        return;
      }

      const respone = case_info_response.data.data;
      this.case_detail_modal.caseInfo = respone;
      var totalRate = this.case_detail_modal.caseInfo.items
        .map((_) => _.viewRate)
        .reduce((a, b) => a + b, 0);
      this.case_detail_modal.caseInfo.items.forEach((item, index) => {
        item.viewRate = Math.ceil((item.viewRate / totalRate) * 10000) / 100;
      });
      this.case_detail_modal.flag = true;
    },
    handleSelectBox(item) {
      if (this.totalSelectedCount >= 5) {
        this.$toast.error("创建多人开箱一局最多 5 个盲盒!");
        return;
      }
      if (item.count >= 1) {
        this.$toast.error("每个盲盒最多选择一个!");
        return;
      }
      item.count++;
    },
    handleCancelSelect(item) {
      if (!item.caseId || item.count <= 0) return;
      // 饰品箱列表
      item.count--;
    },
    handleLowCountReduceSelect() {
      if (this.lowCount <= 1) return;
      this.lowCount--;
    },
    handleLowCountAddSelect() {
      if (
        this.lastShowPrice >=
          this.totalSelectedPrice * this.mpcCaseSettings.mpCaseMaximumPercent &&
        this.lastShowPrice != 0
      ) {
        this.$toast.error(`已达到当前可合开最大份额`);
        return;
      }
      this.lowCount++;
    },
    // 最低出资金额校验
    onLowCountInput(e) {
      this.lowCount = e.target.value.replace(/[^0-9]/g, "");
    },
    onLowCountBlur() {
      if (this.lowCount == "" || this.lowCount <= 1) {
        this.lowCount = 1;
      }
    },
    handleNewCase() {
      if (this.loading) return;
      if (this.caseData.length === 0) {
        this.$toast.error("请选择盲盒");
        return;
      }
      if (this.totalSelectedPrice < this.mpcCaseSettings.mpCaseMinimumPrice) {
        this.$toast.error(
          `创建合开最低价格为${this.mpcCaseSettings.mpCaseMinimumPrice}元`
        );
        return;
      }

      this.loading = true;

      var caseIds = [];

      this.caseData.forEach((item) => {
        if (item.count > 0) {
          caseIds = caseIds.concat(Array(item.count).fill(item.caseId));
        }
      });

      const data = {
        PieceCount: this.lowCount,
        CaseIds: caseIds,
        password: this.roomPassword,
      };

      this.$emit("createNewCase", data);

      // 记录上一次创建的内容
      localStorage.setItem(
        "lastCreateNewCase",
        JSON.stringify({
          roomPassword: this.roomPassword,
          caseData: this.caseData,
        })
      );
    },
    handleReset() {
      this.caseData.forEach((item) => {
        item.count = 0;
      });
    },
    lastCreateFunc() {
      let data = null;
      try {
        data = JSON.parse(localStorage.getItem("lastCreateNewCase") || "");
      } catch {}
      if (data) {
        this.roomPassword = data.roomPassword;
        this.caseData = data.caseData;
      }
    },
  },
};
